/* eslint-disable max-len */
/* eslint-disable no-undef */
/* eslint-disable no-unused-vars */

import { PolymerElement } from "@polymer/polymer/polymer-element.js";
import { html } from "@polymer/polymer/lib/utils/html-tag.js";
import template from "./ns-region-selection.html";
import nuskin2008Logo from "../assets/NuSkin_2008_logo.png";
import { RunConfigService, events } from "@nuskin/ns-util";

/**
 * The ns-region-selection should be used for
 *
 * <h1>Region Selection</h1>
 * <demo-snippet class="demoSnippet">
 *   <template>
 *     <ns-region-selection>Sample Button</ns-region-selection>
 *   </template>
 * </demo-snippet>
 *
 */
export class NsRegionSelection extends PolymerElement {
  static get is() {
    return "ns-region-selection";
  }

  static get template() {
    let htmlElement = document.createElement("TEMPLATE");
    htmlElement.innerHTML = template;
    return htmlElement;
  }

  static get properties() {
    return {
      baseUrl: {
        type: String,
        value: "",
        observer: "init"
      },
      /**
       * Sets the selector for the regions list ajax call.
       * Defaults to the global list selector.
       */
      regionsSelector: {
        type: String,
        value: "globallanding",
        observer: "getRegions"
      },
      /**
       * Overrides the url the user is redirected to.
       * Region, country, and language can be dynamically set by using
       * the tags {region}, {country}, and {language}.
       * Example: "/content/mecommerce/{region}/{country}/{language}/home.html"
       */
      urlPattern: {
        type: String,
        value: ""
      },
      selectRegionTitle: {
        type: String,
        value: "Select Your Market"
      },
      currentDisplayCountry: {
        type: String,
        value: "United States"
      },
      currentCountryCode: {
        type: String,
        value: "US"
      },
      currentDisplayLanguage: {
        type: String,
        value: "English"
      },
      currentLanguageCode: {
        type: String,
        value: "en"
      },
      viewOtherRegions: {
        type: String,
        value: "Other Region"
      },
      regions: {
        type: Array,
        notify: true
      },
      showOtherRegions: {
        type: Boolean,
        value: false
      },
      currentCountryFlagImage: String,
      active: {
        type: String,
        value: "inactive"
      },
      localeIndex: Object,
      expandbreakpoint: String,
      open: String,
      location: {
        type: String,
        value: "footer"
      },
      countryTranslationOverrides: {
        type: Array,
        value: []
      },
      regionLabelOverrides: {
        type: Array,
        value: []
      }
    };
  }
  ready() {
    super.ready();

    if (this.location === "global-landing-page") {
      this.shadowRoot.querySelector(".popup-banner").style.backgroundImage =
        "url(" + nuskin2008Logo + ")";
    }
    this.init();
  }

  init() {
    if (this.baseUrl) {
      if (!this.regions) {
        this.getRegions();
      } else {
        this._handleResponse();
      }
    }
  }

  getRegions() {
    let url = `${RunConfigService.getBaseUrl()}/apps/hello/services/regions.${
      this.regionsSelector
    }.json`;

    $.ajax({
      type: "GET",
      url: url,
      contentType: "application/json"
    })
      .done((data) => {
        this._handleResponse(data);
      })
      .fail((data) => {
        console.error("Failed to get region data: ", data);
      });
  }

  getRegionImageSrc(region) {
    let icon = "";

    switch (region) {
      case "north_america":
        icon = "/content/dam/apps/global_landing_page/region-north_america.svg";
        break;
      case "central_south_america":
        icon =
          "/content/dam/apps/global_landing_page/region-central_south_america.svg";
        break;
      case "europe":
        icon = "/content/dam/apps/global_landing_page/region-europe.svg";
        break;
      case "greater_china":
        icon = "/content/dam/apps/global_landing_page/region-greater_china.svg";
        break;
      case "asia_pacific":
        icon = "/content/dam/apps/global_landing_page/region-asia_pacific.svg";
        break;
      case "middle_east_africa":
        icon =
          "/content/dam/apps/global_landing_page/region-middle_east_africa.svg";
        break;
    }
    return this.baseUrl + icon;
  }

  _setMarketLink(languageIndex, country, region) {
    if (this.urlPattern) {
      return (
        this.baseUrl +
        this.urlPattern
          .replace(/{region}/g, region)
          .replace(/{country}/g, country.countryCode)
          .replace(/{language}/g, country.languageCodes[languageIndex])
      );
    } else if (this.baseUrl.indexOf("mynuskin") !== -1) {
      return (
        this.baseUrl +
        "/content/mecommerce/" +
        region +
        "/" +
        country.countryCode +
        "/" +
        country.languageCodes[languageIndex] +
        "/"
      );
    } else {
      if (country.countryCode === "KR") {
        return this._findCountryLanguagePath(
          country,
          country.languageCodes[languageIndex],
          region
        ) + "/";
      } else {
        return (
          this._findCountryLanguagePath(
            country,
            country.languageCodes[languageIndex],
            region
          ) + "/"
        );
      }
    }
  }

  _getRegionLabel(regionName, defaultLabel, currentLanguageCode) {
    for (let i = 0; i < this.regionLabelOverrides.length; i++) {
      let regionLabelOverride = JSON.parse(this.regionLabelOverrides[i]);
      if (regionName === regionLabelOverride.regionName) {
        if (regionLabelOverride.languageCode === currentLanguageCode) {
          return regionLabelOverride.translatedValue;
        }
      }
    }

    return defaultLabel;
  }

  _getLocaleCountryName(country, languageCode) {
    //Check first if country has override value
    if (this.countryTranslationOverrides) {
      for (let i = 0; i < this.countryTranslationOverrides.length; i++) {
        let override = JSON.parse(this.countryTranslationOverrides[i]);
        if (
          override.hasOwnProperty("countryCode") &&
          override.countryCode.toUpperCase() ===
            country.countryCode.toUpperCase()
        ) {
          if (
            override.hasOwnProperty("languageCode") &&
            override.languageCode.toLowerCase() === languageCode.toLowerCase()
          ) {
            if (override.hasOwnProperty("translatedValue")) {
              return override.translatedValue;
            }
          }
        }
      }
    }

    // If not override get name from service
    for (let i = 0; i < country.locale_names.length; i++) {
      if (country.locale_names[i].hasOwnProperty(languageCode)) {
        return country.locale_names[i][languageCode];
      }
    }
  }

  _findCountryLanguagePath(country, language, region) {
    if (this.regions) {
      for (let i = 0; i < this.regions.length; i++) {
        if (this.regions[i].regionname === region) {
          for (let j = 0; j < this.regions[i].countryname.length; j++) {
            if (
              this.regions[i].countryname[j].countryCode === country.countryCode
            ) {
              for (
                let k = 0;
                k < this.regions[i].countryname[j].paths.length;
                k++
              ) {
                if (
                  this.regions[i].countryname[j].paths[k].hasOwnProperty(
                    language
                  )
                ) {
                  return this.regions[i].countryname[j].paths[k][language];
                }
              }
            }
          }
        }
      }
    }
  }

  _hideCountryFlag(countryCode) {
    return ["TW", "HK", "CN"].includes(countryCode);
  }

  togglePopup() {
    // Fix for iw_IL (rtl) in Chrome browser : the popup is to the left of the field, a bit offscreen
    let popupElement = this.shadowRoot.querySelector("div.popup");
    let popupPosition = popupElement.getBoundingClientRect();
    if (popupPosition.left < 0) {
      let css = "div.popup { right: unset !important; }";
      this.shadowRoot
        .querySelector("style")
        .appendChild(document.createTextNode(css));
    }

    let POPUP_BREAKPOINT = 992;
    let width = window.innerWidth;
    let isChange = false;
    switch (this.expandbreakpoint) {
      case "all":
        break;
      case "tablet":
        if (width < POPUP_BREAKPOINT) isChange = true;
        break;
      case "none":
        isChange = true;
        break;
      default:
        if (width < POPUP_BREAKPOINT) isChange = true;
        break;
    }
    if (isChange)
      document.body.style.overflow =
        document.body.style.overflow === "hidden" ? "auto" : "hidden";

    this.active = this.active === "active" ? "inactive" : "active";
    setTimeout(
      function(self) {
        self.showOtherRegions = false;
      },
      300,
      this
    );
  }

  sortCountriesAlphabetically(a, b) {
    if (a.name.toLowerCase() < b.name.toLowerCase()) return -1;
    if (a.name.toLowerCase() > b.name.toLowerCase()) return 1;
    return 0;
  }

  _handleResponse(data) {
    if (!this.regions && data) {
      this.regions = data;
    }

    let localeIndex = localStorage.getItem("localeIndex");
    if (localeIndex !== null) {
      localeIndex = localeIndex.split(",");
      this.localeIndex = {
        region: localeIndex[0],
        country: localeIndex[1],
        language: localeIndex[2]
      };
    }
    if (
      !(
        this.localeIndex &&
        this.regions[this.localeIndex.region].countryname[
          this.localeIndex.country
        ].countryCode === this.currentCountryCode &&
        this.regions[this.localeIndex.region].countryname[
          this.localeIndex.country
        ].languageCodes[this.localeIndex.language] === this.currentLanguageCode
      )
    ) {
      this._setLocaleIndex();
    }

    this.currentRegion = this.regions[this.localeIndex.region];
    this.regionIndex = this.localeIndex.region;
    for (let i in this.regions)
      this.set("regions." + i + ".active", "inactive");
    this.set("regions." + this.regionIndex + ".active", "active");
    this._setCurrentLocaleData();
  }

  _setLocaleIndex() {
    if (this.regions) {
      for (let r = 0; r < this.regions.length; r++) {
        let countries = this.regions[r].countryname;
        for (let c = 0; c < countries.length; c++) {
          let country = countries[c];
          if (country.countryCode === this.currentCountryCode) {
            for (let l = 0; l < country.languageCodes.length; l++) {
              if (country.languageCodes[l] === this.currentLanguageCode) {
                this.localeIndex = {
                  region: r,
                  country: c,
                  language: l
                };
                localStorage.setItem(
                  "localeIndex",
                  this.localeIndex.region +
                    "," +
                    this.localeIndex.country +
                    "," +
                    this.localeIndex.language
                );
                return;
              }
            }
          }
        }
      }
      // set default if no index found
      this.localeIndex = { region: 0, country: 0, language: 0 };
      localStorage.setItem(
        "localeIndex",
        this.localeIndex.region +
          "," +
          this.localeIndex.country +
          "," +
          this.localeIndex.language
      );
    }
  }

  setShowOtherRegions() {
    this.showOtherRegions = true;
  }

  regionSelect(e) {
    let model = e.model;
    if (model.item.active !== "active") {
      for (let i = 0; i < this.regions.length; i++) {
        if (this.get("regions." + i + ".active") === "active")
          this.set("regions." + i + ".active", "inactive");
      }
      model.set("item.active", "active");
    }
  }

  _setCurrentLocaleData() {
    if (this.localeIndex) {
      this.regionIndex = this.localeIndex.region;
      this.currentRegion = this.regions[this.localeIndex.region];
      let country = this.currentRegion.countryname[this.localeIndex.country];
      this.currentLanguage = country.languages[this.localeIndex.language];
      if (this.regions) {
        this.currentCountry = country.name;
        this.currentCountryFlagImage = this.baseUrl + country.cImage;
      }
    }
  }

  _setLocale(e) {
    e.preventDefault();
    let element = e.target;
    let languageIndex = element.getAttribute("data-language-index");
    let countryIndex;
    let regionIndex;
    while (!countryIndex && element) {
      element = element.parentNode;
      if (element && element.getAttribute("data-country-index")) {
        countryIndex = element.getAttribute("data-country-index");
      }
    }
    while (!regionIndex && element) {
      element = element.parentNode;
      if (element && element.getAttribute("data-region-index")) {
        regionIndex = element.getAttribute("data-region-index");
      }
    }

    this.regionIndex = regionIndex;
    this.localeIndex = {
      region: regionIndex,
      country: countryIndex,
      language: languageIndex
    };
    localStorage.setItem(
      "localeIndex",
      this.localeIndex.region +
        "," +
        this.localeIndex.country +
        "," +
        this.localeIndex.language
    );
    let href = e.target.getAttribute("href");
    events.publish("regionSelect", href);
    window.location.href = href;
  }
}

customElements.define(NsRegionSelection.is, NsRegionSelection);
